module.exports = __webpack_public_path__ + "static/hill-0b1267a39ca287c5fd6a9bfb73fc163a.svg";